import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/NFTTicketCounterABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_TICKET_COUNTER } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, NFT_TICKET_COUNTER);
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, NFT_TICKET_COUNTER);
  }
  return contractSender;
}

async function getIncentiveCounterLimit() {
  const res = await getContractReader().methods.incentiveSellingLimit().call();
  return parseInt(res);
}

async function getRoundData() {
  try {
    const res = await getContractReader().methods.getCurrentRound().call();
    return res;
  } catch (error) {
    console.error(error);
  }
}

async function getIncentiveCounterPrice() {
  const res = await getContractReader().methods.incentiveSellingPrice().call();
  return parseInt(res);
}

async function getCurrentRoundRemainingTime() {
  try {
    const res = await getContractReader().methods.getCurrentRoundRemainingTime().call();
    return res;
  } catch (error) {
    console.error(error);
  }
}

async function getCounterBuyingPrice() {
  const res = await getContractReader().methods.getCurrentSellPrice().call();
  return parseInt(res);
}

async function getRoundIndexes(index) {
  const res = await getContractReader().methods.roundIndexes(index).call();
  return res;
}

async function getBonding() {
  const res = await getContractReader().methods.bonding().call();
  return res;
}

async function getRoundConfig() {
  try {
    const res = await getContractReader().methods.roundConfig().call();
    return res;
  } catch (error) {
    console.error(error);
  }
}

async function getCounterParameter() {
  const res = await getContractReader().methods.counterParameter().call();
  return res;
}

async function getUserBuyLimit() {
  const res = await getContractReader().methods.userLimitBuy().call();
  return parseInt(res);
}

async function getUserSellLimit() {
  const res = await getContractReader().methods.userLimitSell().call();
  return parseInt(res);
}

async function sellToCounterIncentive(dispatch, accountAddress, quantity) {
  const emit = getContractSender().methods.sellToCounterIncentive(quantity).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Selling Incentive Ticket");
  return await emit;
}

async function buyFromCounter(dispatch, accountAddress, tick, maxPrice) {
  const emit = getContractSender()
    .methods.buyFromCounter(accountAddress, tick, maxPrice)
    .send({ from: accountAddress });
  handleEmit(dispatch, emit, "Buy From Counter");
  return await emit;
}

async function sellToCounter(dispatch, accountAddress, tickSell, minPrice) {
  const emit = getContractSender().methods.sellToCounter(tickSell, minPrice).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Sell To Counter");
  return await emit;
}

export default {
  ABI,
  ADDRESS: NFT_TICKET_COUNTER,
  getIncentiveCounterPrice,
  getIncentiveCounterLimit,
  getCounterBuyingPrice,
  sellToCounterIncentive,
  buyFromCounter,
  sellToCounter,
  getRoundData,
  getCurrentRoundRemainingTime,
  getRoundIndexes,
  getRoundConfig,
  getCounterParameter,
  getUserBuyLimit,
  getUserSellLimit,
  getBonding,
};
